import { render, staticRenderFns } from "./ProgramDetail.vue?vue&type=template&id=4799694c"
import script from "./ProgramDetail.vue?vue&type=script&lang=js"
export * from "./ProgramDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports